import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './page/Home';
import Intr from './page/Intr';
import Busi from './page/Busi';
import Loca from './page/Loca';

const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/intr' element={<Intr />} />
      <Route path='/busi' element={<Busi />} />
      <Route path='/loca' element={<Loca />} />
    </Routes>
  );
};

export default Router;